import { useState, useEffect } from 'react';

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return width;
};
export default useWindowWidth;

export const formatCurrency = (amount, locale = "en-GB", currency = "GBP") => {
  let value =
    typeof amount === "number"
      ? amount
      : Number(amount?.replace(/[^\d.-]/g, ""));
  value = isNaN(value) ? 0 : value;
  const roundedValue = value.toFixed(2);
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(roundedValue);
};

export function getNewFileName(oldFileName) {
  const extension = oldFileName?.slice(oldFileName?.lastIndexOf('.'));
  const baseName = oldFileName?.slice(0, oldFileName?.lastIndexOf('.'));
  const randomString = Math.random().toString(36).substring(2, 12);
  return `${baseName}-${randomString}${extension}`;
}

export function extractOriginalFileName(modifiedFileName) {
  const extensionIndex = modifiedFileName?.lastIndexOf('.');
  const extension = modifiedFileName?.slice(extensionIndex);
  const randomStringPattern = /-\w{10}(?=\.\w+$)/;
  const baseName = modifiedFileName?.replace(randomStringPattern, '');
  return baseName;
}